import { isBeforeIn, type Granularity } from '@myre/common-dates';

import {
  type AbstractControl,
  type ValidationErrors,
  type ValidatorFn,
} from '@angular/forms';
import { formatISO } from 'date-fns';

export function dateMinValidator(
  date: Date,
  granularity: Granularity,
  dateFormatter: (date: Date) => string = d => (d ? formatISO(d) : ''),
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return date && isBeforeIn(control.value, date, granularity)
      ? {
          [dateFormatter(date)]: true,
        }
      : null;
  };
}
